import React from 'react';
import dayjs, { Dayjs } from 'dayjs';
import classNames from 'classnames';

import { IconChevronLeft, IconChevronRight } from '@pentabd/icons';

import Text from '../../text/Text';
import { Button } from '../../button';
import { SELECT_VIEW } from './constant';

interface Props {
  range?: boolean;
  displayDate: Dayjs;
  showDate: () => string;
  setDisplayedDate: (data: Dayjs) => void;
  setActiveSelectView: (data: string) => void;
  onSelectToday: () => void;
  minDate: Dayjs;
  maxDate: Dayjs;
  isMonthPicker?: boolean;
  isYearPicker?: boolean;
}

function DatePickerHeader({
  range,
  displayDate,
  showDate,
  setDisplayedDate,
  setActiveSelectView,
  onSelectToday,
  minDate,
  maxDate,
  isMonthPicker,
  isYearPicker,
}: Props) {
  const previousMonth = () =>
    setDisplayedDate(dayjs(displayDate).subtract(1, 'months'));

  const nextMonth = () => setDisplayedDate(dayjs(displayDate).add(1, 'months'));

  const disabled = (dates: Dayjs) => {
    return (
      (minDate && dates.isBefore(minDate, 'day')) ||
      (maxDate && dates.isAfter(maxDate, 'day'))
    );
  };

  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-10">
        <div
          className={classNames('pointer', {
            'opacity-25': isMonthPicker || isYearPicker,
          })}
          onClick={
            !isMonthPicker && !isYearPicker
              ? previousMonth
              : () => {
                  console.log('');
                }
          }
        >
          <IconChevronLeft size={20} />
        </div>

        <div className="d-flex gap-6">
          {!isYearPicker ? (
            <div
              className="pointer"
              onClick={() => !range && setActiveSelectView(SELECT_VIEW.MONTH)}
            >
              <Text size="md" color="dark">
                {displayDate?.format('MMMM')}
              </Text>
            </div>
          ) : null}
          {!isMonthPicker ? (
            <div
              className="pointer"
              onClick={() => !range && setActiveSelectView(SELECT_VIEW.YEAR)}
            >
              <Text size="md" color="dark">
                {displayDate?.format('YYYY')}
              </Text>
            </div>
          ) : null}
        </div>

        <div
          className={classNames('pointer', {
            'opacity-25': isMonthPicker || isYearPicker,
          })}
          onClick={
            !isMonthPicker && !isYearPicker
              ? nextMonth
              : () => {
                  console.log('');
                }
          }
        >
          <IconChevronRight size={20} />
        </div>
      </div>

      {!isMonthPicker && !isYearPicker ? (
        <div className="d-flex gap-6 px-8">
          <Button
            fill="outline"
            type="light"
            className="fw-normal text-start flex-fill"
          >
            {showDate() || <Text color="subtitle2">Select date</Text>}
          </Button>

          {!range ? (
            <Button
              fill="outline"
              type="light"
              onClick={onSelectToday}
              disabled={disabled(dayjs())}
            >
              <Text>Today</Text>
            </Button>
          ) : null}
        </div>
      ) : null}
    </>
  );
}

export default DatePickerHeader;
